import { Card } from '@gomi/component';
import { ResponsiveBar } from '@nivo/bar';
import { max } from 'lodash-es';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTopSellingProducts } from '@/hooks/home/useTopSellingProducts';
import { getTextWidth } from '@/lib/getTextWidth';
import { useStore } from '@/stores';
import { HomeEmpty } from '@/views/home/Empty';
import { padding } from '@/views/home/TopSellingBrands';

export const TopSellingProducts = observer(() => {
  const { t } = useTranslation(['home']);
  const {
    homeModel: { startDate, endDate },
  } = useStore();
  const { data, isLoading } = useTopSellingProducts({
    startDate,
    endDate,
  });
  const chartData = data
    .map((d) => ({
      productName: d.productName,
      value: d.count,
    }))
    .sort((a, b) => a.value - b.value);

  return (
    <Card header={t('home:dashboard.topSellingProduct.title')} loading={isLoading}>
      <div className='gm-h-[12rem] gm-text-sm'>
        {(!data.length && <HomeEmpty />) || null}
        {(data.length && (
          <ResponsiveBar
            data={chartData}
            keys={['value']}
            indexBy='productName'
            margin={{
              top: 0,
              right: 0,
              bottom: 0,
              left: max(
                chartData.map((item) => getTextWidth(item.productName, '11px', 25)),
              ),
            }}
            padding={padding[chartData.length]}
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={(bar) => (bar.index !== chartData.length - 1 ? '#D9D9D9' : '#1890FF')}
            layout='horizontal'
            enableGridY={false}
            enableGridX={false}
            borderColor={{
              from: 'color',
              modifiers: [['darker', 1.6]],
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={null}
            labelTextColor={{
              from: 'color',
              modifiers: [['darker', 1.6]],
            }}
            role='application'
          />
        )) ||
          null}
      </div>
    </Card>
  );
});
